export default interface TipoFeriadoModel {
    name:string;
    descricao:string;
}

export const tiposFeriadosList:TipoFeriadoModel[] = [
    { name:"NACIONAL", descricao:"Nacional" },
    { name:"ESTADUAL", descricao:"Estadual" },
    { name:"MUNICIPAL", descricao:"Municipal" },
    
]